// RC6 — Banco de Horas: nomenclatura e economia (camada de exibição apenas).
// Nenhuma alteração estrutural: deriva tier de package_hours/hours_total.
export const TIER_BY_HOURS = { 4: "Experience", 16: "Start", 32: "Professional", 64: "Business", 96: "Corporate VIP" };

const catKeyword = (s = "") => {
  const t = (s || "").toLowerCase();
  if (t.includes("consult")) return "consultorio";
  if (t.includes("escrit")) return "escritorio";
  if (t.includes("reuni")) return "reuniao";
  if (t.includes("cowork") || t.includes("esta\u00e7\u00e3o") || t.includes("estacao")) return "coworking";
  return "";
};
const CAT_LABEL = { coworking: "Coworking", escritorio: "Escritório Executivo", consultorio: "Consultório", reuniao: "Sala de Reunião" };

export function planKeyword(p = {}) {
  return catKeyword(`${p.category || ""} ${p.name || p.plan_name || ""}`);
}

// Categoria canônica para agrupamento/exibição (normaliza "Estação de trabalho" → "Coworking" etc.)
export function canonicalCategory(p = {}) {
  return CAT_LABEL[planKeyword(p)] || (p.category || "").trim() || "Outros";
}

export function hourBankName(p = {}) {
  const hours = p.package_hours ?? p.hours_total;
  const tier = TIER_BY_HOURS[Number(hours)];
  const raw = p.name || p.plan_name || "";
  if (!tier) return raw;
  const label = CAT_LABEL[planKeyword(p)] || (p.category || "").trim();
  return label ? `Banco de Horas ${tier} — ${label}` : `Banco de Horas ${tier}`;
}

export function avulsoRate(p, spaces = []) {
  const kw = planKeyword(p);
  if (!kw) return 0;
  let rate = 0;
  for (const s of spaces) {
    if (catKeyword(`${s.category || ""} ${s.name || ""}`) === kw) {
      rate = Math.max(rate, Number(s.hourly_rate || 0));
    }
  }
  return rate;
}

// ═══ Precificação dinâmica do Banco de Horas ═══
// Fonte única: taxa avulsa oficial (hourly_rate dos espaços) × desconto progressivo.
// Alterar a taxa avulsa recalcula automaticamente todos os pacotes exibidos no site.
export const DISCOUNT_BY_HOURS = { 4: 0.05, 8: 0.10, 16: 0.15, 32: 0.20, 64: 0.25 };

export function packageDiscount(hours) {
  let d = 0;
  for (const t of Object.keys(DISCOUNT_BY_HOURS).map(Number).sort((a, b) => a - b)) {
    if (Number(hours) >= t) d = DISCOUNT_BY_HOURS[t];
  }
  return d;
}

const r2 = (v) => Math.round(v * 100) / 100;

export function packagePricing(p, spaces = []) {
  const hours = Number(p.package_hours || p.hours_total || 0);
  if (!hours) return null;
  const rate = avulsoRate(p, spaces);
  if (!rate) {
    // Fallback: sem taxa avulsa conhecida, exibe o preço cadastrado
    const price = Number(p.price_package || 0);
    return price > 0
      ? { hours, rate: 0, discount: 0, total: r2(price), perHour: r2(price / hours), avulso: null, save: null }
      : null;
  }
  const discount = packageDiscount(hours);
  const avulso = r2(hours * rate);
  const total = r2(hours * rate * (1 - discount));
  return { hours, rate, discount, total, perHour: r2(total / hours), avulso, save: r2(avulso - total) };
}

// Economia total vs preço avulso — null quando não for realmente positiva
export function economia(p, spaces = []) {
  const hours = Number(p.package_hours || 0);
  const price = Number(p.price_package || 0);
  const rate = avulsoRate(p, spaces);
  if (!hours || !price || !rate) return null;
  const avulso = hours * rate;
  const save = avulso - price;
  return save > 0.5 ? { avulso, save, rate, perHour: price / hours } : null;
}

// Economia já obtida sobre as horas utilizadas — para o card do portal
export function economiaObtida(pkg, plan, spaces = []) {
  if (!plan) return null;
  const used = Number(pkg.hours_used || 0);
  const rate = avulsoRate(plan, spaces);
  const hours = Number(plan.package_hours || pkg.hours_total || 0);
  const price = Number(plan.price_package || 0);
  if (!used || !rate || !hours || !price) return null;
  const save = used * (rate - price / hours);
  return save > 0.5 ? save : null;
}
